<template>
  <div class="card__favorite _mb-4 _px-sm-4">
    <div
      class="d-flex align-center btn_favorite"
      :class="{ _active: favorite }"
      @click="$emit('favorite')"
    >
      <div class="card__btn">
        <svg
          width="22"
          height="23"
          viewBox="0 0 22 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.0948 1.92837C10.4547 1.16162 11.5453 1.16162 11.9052 1.92838L14.1725 6.75831C14.3141 7.05989 14.5965 7.27116 14.9258 7.32177L20.0777 8.1136C20.882 8.2372 21.2098 9.2184 20.6413 9.8006L16.8527 13.6808C16.6309 13.908 16.5302 14.227 16.5813 14.5404L17.4664 19.9672C17.6008 20.7911 16.7261 21.4073 15.9956 21.0033L11.4839 18.5084C11.1828 18.3419 10.8172 18.3419 10.5161 18.5084L6.00445 21.0033C5.27389 21.4073 4.39918 20.7911 4.53357 19.9672L5.41872 14.5404C5.46983 14.227 5.36909 13.908 5.14727 13.6808L1.3587 9.8006C0.790244 9.2184 1.11804 8.23721 1.92229 8.1136L7.07418 7.32177C7.40347 7.27116 7.68592 7.05989 7.82749 6.75831L10.0948 1.92837Z"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <p class="card__btn-txt _fw-500 _fs-sm-16 _mb-0 _ml-1">
        {{
          favorite
            ? $t('interface.video.in_favorite')
            : $t('interface.video.favorite')
        }}
      </p>
    </div>

    <div
      class="d-flex align-center btn_like"
      :class="[
        mobileColumn ? '_ml-4 _mt-sm-4 _ml-sm-0' : '_ml-4',
        { _active: like },
      ]"
      @click="$emit('like')"
    >
      <div class="card__btn">
        <svg
          width="22"
          height="20"
          viewBox="0 0 22 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.4578 2.59133C18.9691 2.08683 18.3889 1.68663 17.7503 1.41358C17.1117 1.14054 16.4272 1 15.7359 1C15.0446 1 14.3601 1.14054 13.7215 1.41358C13.0829 1.68663 12.5026 2.08683 12.0139 2.59133L10.9997 3.63785L9.98554 2.59133C8.99842 1.57276 7.6596 1.00053 6.26361 1.00053C4.86761 1.00053 3.52879 1.57276 2.54168 2.59133C1.55456 3.6099 1 4.99139 1 6.43187C1 7.87235 1.55456 9.25383 2.54168 10.2724L3.55588 11.3189L10.9997 19L18.4436 11.3189L19.4578 10.2724C19.9467 9.76814 20.3346 9.16942 20.5992 8.51045C20.8638 7.85148 21 7.14517 21 6.43187C21 5.71857 20.8638 5.01225 20.5992 4.35328C20.3346 3.69431 19.9467 3.09559 19.4578 2.59133V2.59133Z"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <p class="card__btn-txt _fw-500 _fs-sm-16 _mb-0 _ml-2">
        {{ like ? likesCount : $t('interface.video.like') }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardFavorite',
  props: {
    mobileColumn: { type: Boolean, default: false },
    like: Boolean,
    favorite: Boolean,
    likesCount: Number,
  },
}
</script>

<style lang="scss" scoped>
.card {
  &__btn {
    display: grid;
    place-items: center;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background-color: color(grey-second);
    transition: 0.3s;
    cursor: pointer;

    &-txt {
      color: color(grey-light);
      cursor: pointer;
    }
  }
}

.btn_like {
  & svg {
    // transition: 0.3s;

    & path {
      transition: 0.3s;
      fill: transparent;
    }
  }
  &:hover {
    & svg {
      stroke: #eb4343;
      & path {
        stroke: #eb4343;
        fill: #eb4343;
      }
    }
  }

  &._active {
    & .card__btn {
      background-color: #eb4343;
    }

    & svg {
      & path {
        stroke: #fff;
        fill: #fff;
      }
    }
  }
}

.btn_favorite {
  & svg {
    // transition: 0.3s;

    & path {
      transition: 0.3s;
      fill: transparent;
    }
  }
  &:hover {
    & svg {
      stroke: #f1b434;
      & path {
        stroke: #f1b434;
        fill: #f1b434;
      }
    }
  }

  &._active {
    & .card__btn {
      background-color: #f1b434;
    }

    & svg {
      & path {
        stroke: #fff;
        fill: #fff;
      }
    }
  }
}
</style>
